<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts';
require('echarts/theme/macarons'); // echarts theme
import { debounce } from '@/utils';
import Resource from '@/api/resource';

const dashboardResource = new Resource('dashboard');
export default {
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '470px',
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.initChart();
    this.__resizeHandler = debounce(() => {
      if (this.chart) {
        this.chart.resize();
      }
    }, 100);
    window.addEventListener('resize', this.__resizeHandler);
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    window.removeEventListener('resize', this.__resizeHandler);
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    async initChart() {
      try {
        const result = await dashboardResource.sublist('/sick-animals-per-specie-stats'); // Replace with your actual API endpoint
        const apiData = result;

        if (apiData.success) {
          const speciesLabels = apiData.data.speciesLabels;
          const stats = apiData.data.stats;

          const chartData = stats.map((stat) => ({
            value: stat.total_sick,
            name: stat.specie,
            diseases: stat.diseases.map(disease => `${disease.disease}: ${disease.total_sick}`).join('<br/>'),
          }));

          this.chart = echarts.init(this.$el, 'macarons');

          this.chart.setOption({
            tooltip: {
              trigger: 'item',
              formatter: (params) => {
                return `${params.seriesName} <br/>${params.name} : ${params.value} (${params.percent}%)<br/>${params.data.diseases}`;
              },
            },
            legend: {
              left: 'center',
              bottom: '10',
              data: speciesLabels,
            },
            calculable: true,
            series: [
              {
                name: this.$t('dashboard.sickAnimals'),
                type: 'pie',
                roseType: 'radius',
                radius: [15, 95],
                center: ['50%', '38%'],
                data: chartData,
                animationEasing: 'cubicInOut',
                animationDuration: 2600,
              },
            ],
          });
        } else {
          console.error('Failed to fetch data:', apiData.message);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },

    /* async initChart() {
      try {
        // const response = await fetch('/api/sick-animal-stats'); // Replace with your actual API endpoint
        const apiData = {
          'success': true,
          'data': {
            'speciesLabels': [
              'Caprine',
              'Bovine',
            ],
            'stats': [
              {
                'specie': 'Caprine',
                'total_sick': 337,
                'diseases': [
                  {
                    'disease': 'Parasitose gastro-intestinale',
                    'total_sick': '72',
                  },
                  {
                    'disease': 'Tétanos',
                    'total_sick': '129',
                  },
                  {
                    'disease': 'Peste des Petits Ruminants (PPR)',
                    'total_sick': '64',
                  },
                  {
                    'disease': 'Gale',
                    'total_sick': '52',
                  },
                  {
                    'disease': 'Diarrhée',
                    'total_sick': '20',
                  },
                ],
              },
              {
                'specie': 'Bovine',
                'total_sick': 89,
                'diseases': [
                  {
                    'disease': 'Peste des Petits Ruminants (PPR)',
                    'total_sick': '9',
                  },
                  {
                    'disease': 'Brucellose',
                    'total_sick': '44',
                  },
                  {
                    'disease': 'Rage',
                    'total_sick': '36',
                  },
                ],
              },
            ],
          },
          'message': 'Sick animal statistics retrieved successfully',
        };

        if (apiData.success) {
          const speciesLabels = apiData.data.speciesLabels;
          const stats = apiData.data.stats;

          const chartData = stats.map((stat) => ({
            value: stat.total_sick,
            name: stat.specie,
          }));
          console.log('chartData', chartData);

          this.chart = echarts.init(this.$el, 'macarons');

          this.chart.setOption({
            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b} : {c} ({d}%)',
            },
            legend: {
              left: 'center',
              bottom: '10',
              data: speciesLabels,
            },
            calculable: true,
            series: [
              {
                name: 'Sick Animals',
                type: 'pie',
                roseType: 'radius',
                radius: [15, 95],
                center: ['50%', '38%'],
                data: chartData,
                animationEasing: 'cubicInOut',
                animationDuration: 2600,
              },
            ],
          });
        } else {
          console.error('Failed to fetch data:', apiData.message);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }, */
  },
};
</script>
